module.exports = __webpack_public_path__ + "img/emoji-hand-stop-240x240.ee0e7582.png";